<template>
  <ContentWithImage src="page503" image-order="1" image-order-sm="1" margin="50px 0">
    <text-container>
      <h2 class="h1" v-html="$t(`page503.title`)"/>
      <p v-html="$t(`page503.text`)"/>
    </text-container>
  </ContentWithImage>
</template>

<script>
import { ContentWithImage } from '@/components/ui'

export default {
  name: 'Page503',
  components: { ContentWithImage }
}
</script>

<style lang="sass" scoped>
</style>



// WEBPACK FOOTER //
// src/components/errors/Page503.vue